import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import SaveDialogBase from './SaveDialogBase';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Tr from 'translations/Translations';
import { connect } from 'react-redux'


const style = theme => ({
	root: {

	},
	icon: {
		color: theme.palette.common.error,
	}
})

function SaveDialogError({
	classes,
	onClose,
	message,

}) {

	return (
		<SaveDialogBase
			onClose={onClose}
			title={Tr('failure')}
			Icon={HighlightOffIcon}
			iconClassName={classes.icon}
		>
			<Typography variant='body1'>
				{message}
			</Typography>
		</SaveDialogBase>
	)
}

SaveDialogError.propTypes = {
	classes: PropTypes.any,
}

export default connect((state) => ({
	message: state.store.saveStatusMessage
}), {

})(withStyles(style)(SaveDialogError));